import { Pagination, createStyles, Button, Group } from "@mantine/core";
import React from "react";
import { IoArrowForward , IoArrowBack } from "react-icons/io5";

const useStyles = createStyles((theme) => ({
  paginationWrapper: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  },
  control: {
    border: "none",
    backgroundColor: "transparent",
    color: theme.colors.gray[7],
    "&:hover": {
      backgroundColor: theme.colors.gray[7] + " !important",
      color: theme.colors.gray[2] + " !important",
    },
    "&[data-active]": {
      backgroundColor: theme.colors.gray[2],
      color: theme.colors.gray[7],
      fontWeight: 500,
    },
    "&:first-child": {
      display:'none'
    },
    "&:last-child": {
      display:'none'
    },
  },
  dots: {
    color: theme.colors.gray[6],
  },
  arrowButton: {
    color: theme.colors.gray[7],
    backgroundColor: "transparent",
    border: "none",
    padding: "0.3rem 0.6rem",
    cursor: "pointer",
    display:'flex',
    alignItems:'center',
    fontSize:18,
    gap:'.5rem',
    "&:hover": {
      backgroundColor: theme.colors.gray[2],
    },
    // "&:disabled": {
    //   color: theme.colors.gray[4],
    //   cursor: "default",
    // },
  },
}));

const CustomInvoicePagination = ({ data, itemsPerPage, currentPage, handlePageChange }) => {
  const { classes } = useStyles();
  const totalPages = Math.ceil(data / itemsPerPage);

  return (
    <div className={classes.paginationWrapper}>
      <button
        className={classes.arrowButton}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <IoArrowBack size={20} />
        Previous
      </button>

      <Pagination
        total={totalPages}
        value={currentPage}
        onChange={handlePageChange}
        classNames={{
          control: classes.control,
          dots: classes.dots,
        }}
        siblings={1}
        boundaries={1}
      />

      <button
        className={classes.arrowButton}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next 
        <IoArrowForward size={20} />
      </button>
    </div>
  );
};

export default CustomInvoicePagination;
